import { Helmet } from "react-helmet";
import Navbar from "../../../../components/Navbar/Navbar";
import WhatsAppWidget from "../../../../components/Navbar/Whatsapp";
import Banner from "../../../../components/body/projectPageComponents/Banner";
import Overview from "../../../../components/body/projectPageComponents/Overview";
import Pricing from "../../../../components/body/projectPageComponents/Pricing";
import Gallery from "../../../../components/body/projectPageComponents/Gallery";
import Location from "../../../../components/body/projectPageComponents/Location";
import Highlights from "../../../../components/body/projectPageComponents/Highlights";
import SiteVisitBanner from "../../../../components/body/projectPageComponents/SiteVisitBanner";
import FloorPlans from "../../../../components/body/projectPageComponents/FloorPlans";
import Amenities from "../../../../components/body/projectPageComponents/Amenities";
import Faq from "../../../../components/body/projectPageComponents/Faq";
import SimilarProject from "../../../../components/body/projectPageComponents/SimilarProject";

import { projectsmantri } from "../../../../data/projects/mantri/data";
import { projectspurvankara } from "../../../../data/projects/puravankara/data";

export const PurvankaraBlubelle = () => {
  const {
    blubelle: {
      form_data,
      whatsapp,
      bannerdata,
      overview,
      sitevisit,
      pricing,
      floor_plan,
      highlights,
      location,
      gallery,
      faq,
      similar
    }
  } = projectspurvankara;

  return (
    <>
      <Helmet>
        <title>Puravankara Purva Blubelle, Rajajinagar, Bengaluru – Luxury 3 BHK Apartments</title>

        <meta
          name="description"
          content="Discover Puravankara Purva Blubelle in Rajajinagar, Bengaluru – premium 3 BHK apartments with modern amenities, excellent connectivity, and a prime location. Explore pricing, floor plans, and more."
        />

        <meta
          name="keywords"
          content="Puravankara Purva Blubelle, Purva Blubelle Bengaluru, Purva Blubelle Rajajinagar, Puravankara Rajajinagar, Purva Blubelle price, Purva Blubelle floor plan, luxury apartments Bengaluru"
        />

        <link
          rel="canonical"
          href="https://propertystation.in/puravankara-purvabluebelle-rajajinagar-bengaluru"
        />

        <meta
          name="robots"
          content="index, follow"
        />

      </Helmet>

      <WhatsAppWidget whatsappdata={whatsapp} />
      <Navbar />

      <div className="mt-20">
        <Banner
          bannerDesktopImage={bannerdata.bannerDesktopImage}
          bannerMobileImage={bannerdata.bannerMobileImage}
          data={bannerdata.data}
          formData={form_data}
        />
        <Overview overviewData={overview} stripdata={overview.stripdata} />
        <SiteVisitBanner image={sitevisit.image} formData={form_data} />
        <Pricing pricingData={pricing} formData={form_data} />
        <FloorPlans floorPlans={floor_plan} formData={form_data} />
        <Highlights hightlightData={highlights} formData={form_data} />
        <Amenities />
        <Location location={location} />
        <Gallery galleryData={gallery} />
        <Faq faqdata={faq} />
        <SimilarProject Similarprojects={similar} />
      </div>
    </>
  );
};
